import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {NbMenuItem, NbMenuService} from '@nebular/theme';
import {UserService} from '@core/services/user.service';
import {filter, takeUntil} from 'rxjs/operators';
import {DestroyObsService} from '@core/services/destroy-obs.service';
import {IUser} from '@core/models/user';
import {AuthService} from '@core/services/auth.service';
import {SideNavService} from '@core/services/side-nav.service';

@Component({
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss'],
    providers: [DestroyObsService],
    changeDetection: ChangeDetectionStrategy.Default
})
export class SideNavComponent implements OnInit {
    menuItems: NbMenuItem[];
    user$ = this.userService.getUser$;

    constructor(private userService: UserService,
                private authService: AuthService,
                private sideNavService: SideNavService,
                private destroy$: DestroyObsService) {
    }

    ngOnInit(): void {
        this.user$
            .pipe(filter(f => !!f), takeUntil(this.destroy$))
            .subscribe(user => {
                this.menuItems = [
                    {
                        group: true,
                        title: 'ПРЕПОДАВАТЕЛЬ',
                        hidden: user.role === 1
                    },
                    {
                        title: 'Список тестируемых',
                        hidden: user.role === 1,
                        link: '/page/groups/list',
                        icon: 'work',
                    },
                    {
                        title: 'Мои тесты',
                        hidden: user.role === 1,
                        link: '/page/my-tests',
                        icon: 'list'
                    },
                    {
                        title: 'Проведенные тесты',
                        hidden: user.role === 1,
                        link: '/page/performed-tests',
                        icon: 'checkList'
                    },
                    {
                        title: 'Назначить тест',
                        hidden: user.role === 1,
                        link: '/page/appoint-test',
                        icon: 'calendar'
                    },
                    {
                        title: 'Создать тест',
                        hidden: user.role === 1,
                        link: '/page/test',
                        icon: 'document',
                    },
                    {
                        group: true,
                        title: 'ТЕСТИРУЕМЫЙ',
                    },
                    {
                        title: 'Тесты',
                        link: '/page/tests',
                        icon: 'work'
                    },
                ];
            });
    }

    logout() {
        this.authService.logout();
    }

    getName(user: IUser) {
        if (user.surname) {
            const name = user.name?.substr(0, 1);
            const patronymic = user.patronymic?.substr(0, 1);
            return `${user.surname} ${name ? name + '.' : ''} ${patronymic ? patronymic + '.' : ''}`;
        } else {
            return user.email || 'Пользователь';
        }
    }

    onMenuClick() {
        if (window.innerWidth < 768) {
            this.sideNavService.setStatus(false);
        }
    }
}
